const minin = {
  computed: {
    // 是否显示驳回按钮
    showRejectBtn() {
      let boo = false
      // console.log('order', { ...this.order })
      // console.log(this.order.isstatus != 3 || this.order.isover != 2, boo)
      if (this.order.isstatus != 3 || this.order.isover != 2) return boo
      if (this.user && this.detail.isfleet != 2) {
        if ([5].includes(this.user.user_group_id)) {
          boo = true
        }
      }
      return boo
    },
    // 是否显示审核按钮
    showExamineBtn() {
      let boo = false
      // console.log('order', { ...this.order })
      // console.log(this.order.isstatus != 3 || this.order.isover != 2, boo)
      if (this.order.isstatus != 3 || this.order.isover != 2) return boo
      if (this.user && this.detail.isfleet != 2) {
        if ([5].includes(this.user.user_group_id)) {
          boo = true
        }
      }
      return boo
    },
  },
  data() {
    return {
      formCtrl: [
        {
          label: "运单编号",
          keyName: "order_num",
          err: "请填写运单编号",
          type: "text",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
          viewMode: true,
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          viewMode: true,
        },
        // {
        //   label: "货物名称",
        //   keyName: "name",
        //   err: "请填写货物名称",
        //   type: "text",
        //   viewMode: true,
        // },
      ],
      formCtrlOrder0: [],
      formCtrlOrder: [
        {
          label: "加油方式",
          keyName: "gasname",
          err: "请选择加油方式",
          type: "select",
          options: [],
          viewMode: true,
        },
        {
          label: "现金加油(元)",
          keyName: "doil",
          err: "请填写现金加油",
          type: "number",
          viewMode: true,
        },
        {
          label: "非现金加油(元)",
          keyName: "moneydoil",
          err: "请填写油气费",
          type: "number",
          viewMode: true,
        },
        {
          label: "现金票据",
          keyName: "moneyphoto",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          accept: '.png, .jpg, .jpeg, .pdf',
          viewMode: true,
          max: 10,
        },
        {
          label: "非现金票据",
          keyName: "photo",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          accept: '.png, .jpg, .jpeg, .pdf',
          viewMode: true,
          max: 10,
        },
        {
          label: "开始里程数",
          keyName: "ksmileage",
          err: "请填写开始里程数",
          type: "number",
          viewMode: true,
        },
        {
          label: "结束里程数",
          keyName: "jsmileage",
          err: "请填写结束里程数",
          type: "number",
          viewMode: true,
        },
        {
          label: "开始里程单据",
          keyName: "ksmileagephoto",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
        {
          label: "结束里程单据",
          keyName: "jsmileagephoto",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          viewMode: true,
          max: 10,
        },
      ],
      formCtrl2: [
        {
          label: "出车费用票据",
          keyName: "cost_images",
          type: "file",
          ptype: "daypay",
          tips: "图片大小最好不要超过2M",
          accept: '.png, .jpg, .jpeg, .pdf',
          viewMode: true,
          max: 10,
        },
        {
          label: "备注",
          keyName: "remark",
          type: "textarea",
          viewMode: true,
          className: "block",
          rows: 4,
        },
        {
          label: "合计",
          keyName: "total",
          type: "number",
          viewMode: true,
          className: "block",
        },
        // {
        //   label: "司机填写",
        //   keyName: "isover",
        //   type: "select",
        //   viewMode: true,
        //   className: "block",
        //   options: [
        //     { label: '未完成', value: 1 },
        //     { label: '已完成', value: 2 },
        //   ],
        // },
      ],
      getDataUrl: 'money',
      submitUrl: 'examinemoney',
      dayauth: [],
      // 里程单位价格
      unitprice: 0,
      order: {},
      rejectCtrl: {
        label: "驳回原因",
        keyName: "reject_reason",
        type: "textarea",
        viewMode: true,
        className: "block",
        rows: 4,
      },
      gasstation: [],
      // pc端系统设置，判断是否设置显示
      system_cost: [],
      // 系统设置费用累加，判断是否有值，有值则必须显示
      sys_fee: 0,
    };
  },
  methods: {
    getKeys() {
      const formCtrl = [...this.formCtrl]
      const Order = this.formCtrlOrder
      if (Order && Order.length) {
        formCtrl.push(...Order)
      }
      const Order0 = this.formCtrlOrder0
      if (Order0 && Order0.length) {
        formCtrl.push(...Order0)
      }
      const f2 = this.formCtrl2
      if (f2 && f2.length) {
        formCtrl.push(...f2)
      }
      const arr = ['gsid']
      formCtrl.map(v => {
        const key = v.keyName
        if (!['driver', 'shname', 'isstatus', 'is_reject', 'reject_reason', 'total'].includes(key)) {
          arr.push(key)
        }
      })
      return arr
    },
    specialParamsPackage(params) {
      // 已完成运单二次编辑费用
      if (this.form['isstatus'] == 4) {
        params['type'] = 2
      }
      if (!params['isfleet']) {
        params['isfleet'] = this.detail.isfleet
      }
      if (!params['isover']) {
        params['isover'] = this.detail.isover
      }
      if (!params['orderid']) {
        params['orderid'] = this.detail.orderid
      }
      if (!params['gsid'] && params['gsid'] != 0) {
        params['gsid'] = this.detail.gsid
      }
    },
    onChange({ key, value }) {
      console.log(key, value)
      // console.log(Number(value))
      // 所有配置费用项
      const arr = []
      this.dayauth.map(v => {
        // console.log(v.enname, v.id)
        if (v.id != 1) {
          arr.push(v.enname)
        }
      })
      // 加上油气费
      const arr1 = [...arr, 'doil', 'moneydoil', 'unitotal', 'jsmileage', 'ksmileage']
      // console.log(arr1)
      if (value && typeof value === 'object') {
        if (value.length) {
          const o = value.map(v => {
            let result = v
            if (v.response && v.response.photo) {
              result = { url: v.response.photo }
            }
            return result
          })
          this.$set(this.form, key, o)
        } else {
          this.$set(this.form, key, null)
        }
      } else if (arr1.includes(key)) {
        this.$set(this.form, key, value)
        // 实时计算总额
        this.$nextTick(() => {
          let dtotal = 0
          const object = { ...this.form }
          for (const key in object) {
            if (Object.hasOwnProperty.call(object, key) && key.includes('isnum')) {
              const element = object[key];
              // console.log(element)
              dtotal += Number(element)
            }
          }
          const { doil, moneydoil, jsmileage, ksmileage } = this.form
          if (this.form.jsmileage != 0) {
            dtotal += Number(doil) + Number(moneydoil) + (Number(jsmileage) - Number(ksmileage)) * this.unitprice
          } else {
            dtotal += Number(doil) + Number(moneydoil)
          }
          // console.log(dtotal)
          this.form.total = dtotal.toFixed(2)
          this.$forceUpdate()
        })
      } else if (key == 'gasname') {
        this.$set(this.form, key, value)
        this.gasstation.map(c => {
          if (c.gasname == value) {
            this.$set(this.form, 'gsid', c.id)
          }
        })
      } else {
        this.$set(this.form, key, value)
      }
      console.log('form', { ...this.form });
    },
    setDetail({
      data,
      order,
      dayauth,
      gasstation,
      unitprice,
      system_cost,
    }) {
      // 获取order部分信息存入form
      const {
        driver,
        shname,
        isstatus,
        is_reject,
        reject_reason,
      } = order
      // console.log(driver)
      this.form = {
        ...data,
        driver,
        shname,
        isstatus,
        is_reject,
        reject_reason,
      }

      // 储存order
      this.order = {
        ...order,
        isover: data.isover,
      }
      
      // 判断是否显示各类费用信息
      this.system_cost = system_cost || []

      // 加油方式
      this.formCtrlOrder.map(c => {
        if (c.keyName == 'gasname' && gasstation && gasstation.length) {
          this.gasstation = gasstation
          c.options = gasstation.map(v => {
            return {
              label: v.gasname,
              value: v.gasname,
            }
          })
          // console.log(c.options)
        }
      })

      // 里程单位价格
      this.unitprice = unitprice

      // 系统配置的费用项目
      this.dayauth = dayauth
      dayauth.map(v => {
        const key = v.enname
        if (Object.hasOwnProperty.call(this.detail, key)) {
          let label = v.authname + '(元)'
          if (v.authname === '加油量') {
            label = v.authname + '(升)'
            this.formCtrlOrder0.push({
              label,
              keyName: key,
              type: "text",
              viewMode: true,
            })
          } else {
            // 累加计算是否已产生费用
            this.sys_fee += Number(data[v.enname]);
            this.formCtrlOrder.push({
              label,
              keyName: key,
              type: "text",
              viewMode: true,
            })
          }
        }
      })

      this.$forceUpdate()
      // console.log({ ...this.detail })
      // console.log({ ...this.form })
    },
    onRejectSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$prompt('', '驳回原因', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(({ value }) => {
        this.rejectReq(value);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    rejectReq(reject_reason) {
      this.loading = true
      let url = `order/reject`;
      const params = {
        id: this.id,
        userid: this.user.id,
        reject_reason
      }
      this.post(url, params, ({
        msg
      }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '驳回成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '驳回失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    this.formCtrl2.slice(1)
  },
}

export default minin